import { ResizeSensor } from 'css-element-queries';
import StickySidebar from 'sticky-sidebar';

document.addEventListener('DOMContentLoaded', () => {
    window.ResizeSensor = ResizeSensor;

    const campaignSections = document.querySelectorAll('[data-campaign-widget-block]');
    const isCampaighSectionExists = campaignSections?.length;

    if (isCampaighSectionExists) {
        // https://abouolia.github.io/sticky-sidebar/
        // eslint-disable-next-line no-new
        new StickySidebar('.campaign-widget-block-aside', {
            containerSelector: '.campaign-widget-block-wrapper',
            innerWrapperSelector: '.campaign-widget-block-aside__inner',
            topSpacing: 20,
            bottomSpacing: 20,
            resizeSensor: true,
            minWidth: 768,
        });
    }
});

